import { SelectData } from '@occc-app/design-system';
import { Allowed_List_Phone_Number_Time_Period } from '@occc/graphql';

export const enteredOnOptions: SelectData[] = [
  {
    label: 'Last Hour',
    value: Allowed_List_Phone_Number_Time_Period.LastHour,
  },
  {
    label: 'Last 6 hours',
    value: Allowed_List_Phone_Number_Time_Period.Last_6Hours,
  },
  {
    label: 'Last 24 hours',
    value: Allowed_List_Phone_Number_Time_Period.Last_24Hours,
  },
  {
    label: 'Yesterday',
    value: Allowed_List_Phone_Number_Time_Period.Yesterday,
  },
  {
    label: 'Custom Range',
    value: Allowed_List_Phone_Number_Time_Period.Custom,
  },
];
